import axios from "axios";
import authHeader from "../Services/auth-header";
import { refreshToken } from "../Services/auth.service";
import UserProjects from "../Static Files/UserProjects.json";
import { applyRomanFeaturesToOrderDetails } from "./applyRomanFeaturesToOrderDetails";

import { baseURLAddProjectToCart, baseURLEditProject, baseURLGetCart } from "../config/api";
async function AddProjectToCart(
  allBags,
  SewingModelId,
  price,
  ModelNameEn,
  ModelNameFa,
  Files,
  cartProjectIndex,
  editIndex,
  navigate,
  isLoggedIn,
  customAcc,
  returnObj,
  discountedPrice
) {
  console.log(`allBags`, allBags);
  return await new Promise((resolve, reject) => {
    let customPageCart = {};
    let userProjects = JSON.parse(JSON.stringify(UserProjects))[SewingModelId]["data"];
    let temp = JSON.parse(JSON.stringify(allBags));

    let isCompleted = true;

    let tempPostObj = {};
    Object.keys(temp).forEach((key) => {
      if (temp[key] !== undefined && temp[key] !== null && temp[key] !== "") {
        let tempObj = userProjects.find((obj) => obj["cart"] === key);
        if (tempObj && tempObj["apiLabel"] !== "") {
          if (tempObj["apiValue"] === null) {
            tempPostObj[tempObj["apiLabel"]] = temp[key];
          } else {
            tempPostObj[tempObj["apiLabel"]] = tempObj["apiValue"][temp[key]];
          }
        }
      }
    });

    const isDualRoller = String(SewingModelId) === "0325";

    if (isDualRoller) {
      // Dual Roller: backend expects a single SewingOrderDetails item
      tempPostObj["SewingOrderDetails"] = [
        {
          IsLowWrinkle: true,
          IsCoverAll: tempPostObj["PanelCoverage"] === "Decorative" ? false : true,
          IsAltogether: true,
          CurtainPartId: 2303,
          SewingModelId: `${SewingModelId}`,
        },
      ];

      Object.keys(temp).forEach((key) => {
        if (temp[key] !== undefined && temp[key] !== null && temp[key] !== "") {
          let tempObj = userProjects.find((obj) => obj["cart"] === key);
          if (tempObj && tempObj["apiLabel2"] !== undefined) {
            if (tempObj["apiValue2"] === null) {
              tempPostObj["SewingOrderDetails"][0][tempObj["apiLabel2"]] = temp[key];
            } else {
              tempPostObj["SewingOrderDetails"][0][tempObj["apiLabel2"]] =
                tempObj["apiValue2"][temp[key]];
            }
          }
        }
      });
    } else {
      tempPostObj["SewingOrderDetails"] = [];
      for (let i = 0; i < 3; i++) {
        tempPostObj["SewingOrderDetails"][i] = {};
        tempPostObj["SewingOrderDetails"][i]["IsLowWrinkle"] = true;
        tempPostObj["SewingOrderDetails"][i]["IsCoverAll"] =
          i === 0 ? tempPostObj["PanelCoverage"] !== "Decorative" : true;
        tempPostObj["SewingOrderDetails"][i]["IsAltogether"] = true;
      }

      tempPostObj["SewingOrderDetails"][0]["CurtainPartId"] = 2303;
      tempPostObj["SewingOrderDetails"][0]["SewingModelId"] = `${SewingModelId}`;

      tempPostObj["SewingOrderDetails"][1]["CurtainPartId"] = 2302;
      tempPostObj["SewingOrderDetails"][1]["SewingModelId"] = tempPostObj["SewingModelId"];

      tempPostObj["SewingOrderDetails"][2]["CurtainPartId"] = 2301;
      tempPostObj["SewingOrderDetails"][2]["SewingModelId"] = tempPostObj["SewingModelId"];

      Object.keys(temp).forEach((key) => {
        if (temp[key] !== undefined && temp[key] !== null && temp[key] !== "") {
          let tempObj = userProjects.find((obj) => obj["cart"] === key);
          if (tempObj) {
            for (let i = 0; i < 3; i++) {
              let j = +i + +2;
              if (tempObj["apiLabel" + j] !== undefined) {
                if (tempObj["apiValue" + j] === null) {
                  tempPostObj["SewingOrderDetails"][i][tempObj["apiLabel" + j]] = temp[key];
                } else {
                  tempPostObj["SewingOrderDetails"][i][tempObj["apiLabel" + j]] =
                    tempObj["apiValue" + j][temp[key]];
                }
              }
            }
          }
        }
      });
    }

    // Skip accessory mapping for these sewing models
    const skipAccessoryModels = new Set(["0303", "0324", "0325", "0097", "0328", "0327"]);
    const shouldApplyAccessories = !skipAccessoryModels.has(String(SewingModelId));

    if (shouldApplyAccessories) {
      tempPostObj["SewingOrderDetails"][0]["Accessories"] = [];
      tempPostObj["SewingOrderDetails"][1]["Accessories"] = [];
      tempPostObj["SewingOrderDetails"][2]["Accessories"] = [];
      Object.keys(temp).forEach((key) => {
        if (temp[key] !== undefined && temp[key] !== null && temp[key] !== "") {
          let tempObj = userProjects.find((obj) => obj["cart"] === key);
          if (tempObj) {
            if (tempObj["apiAcc"] !== undefined) {
              if (tempObj["apiAcc"] === true && tempObj["apiAccValue"][temp[key]]) {
                tempPostObj["SewingOrderDetails"][0]["Accessories"].push(
                  tempObj["apiAccValue"][temp[key]]
                );
              } else if (tempObj["apiAcc"] === "value") {
                let pushObj = tempObj["apiAccValue"] || {};
                pushObj["SewingAccessoryValue"] = temp[key]?.toString();
                tempPostObj["SewingOrderDetails"][0]["Accessories"].push(pushObj);
              }
            }
            if (tempObj["apiAcc2"] !== undefined) {
              if (tempObj["apiAcc2"] === true && tempObj["apiAccValue2"][temp[key]]) {
                tempPostObj["SewingOrderDetails"][1]["Accessories"].push(
                  tempObj["apiAccValue2"][temp[key]]
                );
              } else if (tempObj["apiAcc"] === "value") {
                let pushObj = tempObj["apiAccValue2"] || {};
                pushObj["SewingAccessoryValue"] = temp[key]?.toString();
                tempPostObj["SewingOrderDetails"][1]["Accessories"].push(pushObj);
              }
            }
            if (tempObj["apiAcc3"] !== undefined) {
              if (tempObj["apiAcc3"] === true && tempObj["apiAccValue3"][temp[key]]) {
                tempPostObj["SewingOrderDetails"][2]["Accessories"].push(
                  tempObj["apiAccValue3"][temp[key]]
                );
              } else if (tempObj["apiAcc"] === "value") {
                let pushObj = tempObj["apiAccValue3"] || {};
                pushObj["SewingAccessoryValue"] = temp[key]?.toString();
                tempPostObj["SewingOrderDetails"][2]["Accessories"].push(pushObj);
              }
            }
          }
        }
      });
    }

    tempPostObj["ModelNameEn"] = ModelNameEn;
    tempPostObj["ModelNameFa"] = ModelNameFa;

    if (tempPostObj["ZipCode"] && tempPostObj["ZipCode"] !== "") {
      tempPostObj["NeedInstall"] = true;
      tempPostObj["InstallAmount"] = tempPostObj["InstallAmount"]
        ? tempPostObj["InstallAmount"]
        : 0;
      tempPostObj["TransportationAmount"] = tempPostObj["TransportationAmount"]
        ? tempPostObj["TransportationAmount"]
        : 0;
    } else {
      tempPostObj["NeedInstall"] = false;
      tempPostObj["InstallAmount"] = 0;
      tempPostObj["TransportationAmount"] = 0;
    }

    if (shouldApplyAccessories) {
      if (customAcc !== undefined && Array.isArray(customAcc) && customAcc.length > 0) {
        tempPostObj["SewingOrderDetails"][0]["Accessories"].push(...customAcc);
      } else if (customAcc !== undefined && Object.keys(customAcc).length > 0) {
        tempPostObj["SewingOrderDetails"][0]["Accessories"].push(customAcc);
      }
      tempPostObj["SewingOrderDetails"][0]["Accessories"] = tempPostObj["SewingOrderDetails"][0][
        "Accessories"
      ].filter((n) => n);
      tempPostObj["SewingOrderDetails"][1]["Accessories"] = tempPostObj["SewingOrderDetails"][1][
        "Accessories"
      ].filter((n) => n);
      tempPostObj["SewingOrderDetails"][2]["Accessories"] = tempPostObj["SewingOrderDetails"][2][
        "Accessories"
      ].filter((n) => n);

      tempPostObj["Accessories"] = tempPostObj["SewingOrderDetails"][0]["Accessories"];
    }

    tempPostObj["SewingModelId"] = `${SewingModelId}`;
    tempPostObj["IsCompleted"] = isCompleted;
    tempPostObj["WindowCount"] = 1;
    tempPostObj["Count"] = 1;
    tempPostObj["IsActive"] = true;
    tempPostObj["Price"] = price;
    // Backend: WindowName = room name, WindowDescription = custom window label.
    // Guest cart is already remapped (WindowDescription set); do not overwrite with WindowName.
    // Fresh UI bags still keep the custom label in WindowName until this remap.
    if (temp["WindowDescription"] !== undefined && temp["WindowDescription"] !== null) {
      tempPostObj["WindowDescription"] = temp["WindowDescription"];
    } else {
      tempPostObj["WindowDescription"] = tempPostObj["WindowName"] || "";
    }
    tempPostObj["WindowName"] =
      tempPostObj["RoomNameEn"] || temp["RoomNameEn"] || tempPostObj["WindowName"] || "";

    // PanelTypeId — apply on original A/B/C layers before empty ones are removed
    const panelTypeIdMap = {
      "Single Panel": 5901,
      "Single Panel, Right": 5902,
      "Pair, Split Draw": 5903,
      "Single, Free Hanging": 5904,
      "Pair, Free Hanging": 5904,
      "Three Panel, Split Draw": 5905,
      "Four Panel, Split Draw": 5906,
    };
    const GrommetFinishMap = {
      "Satin Brass": 13101,
      "Satin Nickel": 13102,
      "Gun Metal": 13103,
    };
    let defaultPanelTypeId;
    let defaultGrommetFinish;
    const getPanelTypeId = (panelType) => panelTypeIdMap[panelType] ?? defaultPanelTypeId;
    const getGrommetFinish = (grommetFinish) =>
      GrommetFinishMap[grommetFinish] ?? defaultGrommetFinish;
    if (tempPostObj["SewingOrderDetails"] && tempPostObj["SewingOrderDetails"][0]) {
      tempPostObj["SewingOrderDetails"][0]["PanelTypeId"] = getPanelTypeId(allBags["PanelTypeA"]);
      if (allBags["GrommetFinish"] && allBags["SewingModelId"] === "0099") {
        tempPostObj["SewingOrderDetails"][0]["GrommetColorId"] = getGrommetFinish(
          allBags["GrommetFinish"]
        );
      }
      if (
        allBags["SheerHeaderStyle"] &&
        allBags["SheerHeaderStyle"] === "Grommet" &&
        allBags["SewingModelId"] === "0099"
      ) {
        tempPostObj["SewingOrderDetails"][1]["GrommetColorId"] = getGrommetFinish(
          allBags["GrommetFinish"]
        );
      }
    }
    if (tempPostObj["SewingOrderDetails"] && tempPostObj["SewingOrderDetails"][1]) {
      tempPostObj["SewingOrderDetails"][1]["PanelTypeId"] = getPanelTypeId(allBags["PanelTypeB"]);
    }
    if (tempPostObj["SewingOrderDetails"] && tempPostObj["SewingOrderDetails"][2]) {
      tempPostObj["SewingOrderDetails"][2]["PanelTypeId"] = getPanelTypeId(allBags["PanelTypeC"]);
    }

    for (let i = tempPostObj["SewingOrderDetails"].length - 1; i >= 0; i--) {
      if (
        tempPostObj["SewingOrderDetails"] &&
        tempPostObj["SewingOrderDetails"][i] &&
        tempPostObj["SewingOrderDetails"][i]["FabricId"] === undefined
      ) {
        tempPostObj["SewingOrderDetails"].splice(i, 1);
      }
    }

    if (cartProjectIndex && cartProjectIndex !== -1) {
      tempPostObj["SewingOrderId"] = cartProjectIndex;
    }
    if (
      tempPostObj["SewingOrderId"] &&
      (tempPostObj["SewingOrderId"] === -1 || tempPostObj["SewingOrderId"] === "-1")
    ) {
      delete tempPostObj["SewingOrderId"];
    }

    Files[0] = Files[0].filter((x) => !!x);
    Files[1] = Files[1].filter((x) => !!x);
    Files[2] = Files[2].filter((x) => !!x);
    Files[3] = Files[3].filter((x) => !!x);

    if (Files[0].length + Files[2].length > 0) {
      tempPostObj["SewingOrderAttachments"] = [];
      Files[0].forEach((obj, index) => {
        tempPostObj["SewingOrderAttachments"].push({
          FileUrl: Files[1][index],
          UserFileName: obj,
        });
      });
      Files[2].forEach((obj, index) => {
        tempPostObj["SewingOrderAttachments"].push({
          FileUrl: Files[3][index],
          UserFileName: obj,
        });
      });
    }

    if (SewingModelId === "0097" || SewingModelId === "0327" || SewingModelId === "0328") {
      if (allBags["borderPosition"]) {
        tempPostObj["borderPosition"] = allBags["borderPosition"];
      }

      if (allBags["BorderOrTrimColorEn"]) {
        tempPostObj["BorderOrTrimColorEn"] = allBags["BorderOrTrimColorEn"];
        tempPostObj["BorderOrTrimColorFa"] = allBags["BorderOrTrimColorFa"];
      }

      if (allBags["BorderOrTrimDesignEn"]) {
        tempPostObj["BorderOrTrimDesignEn"] = allBags["BorderOrTrimDesignEn"];
        tempPostObj["BorderOrTrimDesignFa"] = allBags["BorderOrTrimDesignFa"];
      }
    }

    if (SewingModelId === "0326") {
      tempPostObj["MotorChannels"] = allBags["MotorChannels"];
      tempPostObj["MotorPosition"] = allBags["MotorPosition"];
      tempPostObj["RemoteName"] = allBags["RemoteName"];
    }
    if (
      (SewingModelId === "0303" || SewingModelId === "0324") &&
      allBags["installationLocation"] !== undefined &&
      allBags?.Mount === "Outside"
    ) {
      tempPostObj["installationLocation"] = allBags["installationLocation"];
    }

    // Add fabricItemId for guest users (saved to localStorage)
    if (allBags["fabricItemId"]) {
      tempPostObj["fabricItemId"] = allBags["fabricItemId"];
      if (tempPostObj["SewingOrderDetails"] && tempPostObj["SewingOrderDetails"][0]) {
        tempPostObj["SewingOrderDetails"][0]["fabricItemId"] = allBags["fabricItemId"];
      }
    }

    if (allBags["nameFabricItemEn"]) {
      tempPostObj["nameFabricItemEn"] = allBags["nameFabricItemEn"];
      if (tempPostObj["SewingOrderDetails"] && tempPostObj["SewingOrderDetails"][0]) {
        tempPostObj["SewingOrderDetails"][0]["nameFabricItemEn"] = allBags["nameFabricItemEn"];
      }
    }

    if (allBags["nameFabricItemFa"]) {
      tempPostObj["nameFabricItemFa"] = allBags["nameFabricItemFa"];
      if (tempPostObj["SewingOrderDetails"] && tempPostObj["SewingOrderDetails"][0]) {
        tempPostObj["SewingOrderDetails"][0]["nameFabricItemFa"] = allBags["nameFabricItemFa"];
      }
    }

    if (allBags["statusFabricItem"]) {
      tempPostObj["statusFabricItem"] = allBags["statusFabricItem"];
      if (tempPostObj["SewingOrderDetails"] && tempPostObj["SewingOrderDetails"][0]) {
        tempPostObj["SewingOrderDetails"][0]["statusFabricItem"] = allBags["statusFabricItem"];
      }
    }

    if (
      tempPostObj["SewingModelId"] === "0097" ||
      tempPostObj["SewingModelId"] === "0327" ||
      tempPostObj["SewingModelId"] === "0328" ||
      tempPostObj["SewingModelId"] === "0099" ||
      tempPostObj["SewingModelId"] === "0321"
    ) {
      const liningTypeIdMap = {
        Unlined: 6001,
        "Standard Lining": 6002,
        "Privacy Lining": 6003,
      };
      tempPostObj["SewingOrderDetails"].forEach((detail) => {
        if (detail && detail["LiningId"] !== undefined) {
          delete detail["LiningId"];
        }
      });
      const liningTypeId = liningTypeIdMap[tempPostObj["Lining"]];
      if (liningTypeId !== undefined && tempPostObj["SewingOrderDetails"][0]) {
        tempPostObj["SewingOrderDetails"][0]["LiningTypeId"] = liningTypeId;
      }
    }

    if (String(SewingModelId) === "0326") {
      if (allBags["CurtainArr"]) {
        tempPostObj["CurtainArr"] = allBags["CurtainArr"];
      }
      if (allBags["SodFabrics"]) {
        tempPostObj["SodFabrics"] = allBags["SodFabrics"];
      }
      if (allBags["DkScarfRule"]) {
        tempPostObj["DkScarfRule"] = allBags["DkScarfRule"];
      }
    }

    tempPostObj["PreorderText"] = JSON.parse(JSON.stringify(tempPostObj));

    if (returnObj) {
      resolve(tempPostObj);
    } else {
      if (isLoggedIn) {
        const fieldsToCopy = [
          "MetalValanceStyleId",
          "MetalValanceColorId",
          "BottomBarId",
          "RollTypeId",
          "BracketTypeId",
          "BracketColorId",
          "ChainId",
          "MotorProductId",
          "BackCordSideId",
        ];
        if (
          allBags["HemStyleId"] !== undefined &&
          allBags["HemStyleId"] !== null &&
          allBags["HemStyleId"] !== ""
        ) {
          tempPostObj["SewingOrderDetails"][0]["HemStyleId"] = allBags["HemStyleId"];
        }

        // HeadRailId
        if (
          allBags["HeadRailId"] !== undefined &&
          allBags["HeadRailId"] !== null &&
          allBags["HeadRailId"] !== ""
        ) {
          tempPostObj["SewingOrderDetails"][0]["HeadRailId"] = allBags["HeadRailId"];
        }

        // MetalValanceStyleId - check if available in allBags, otherwise calculate from MetalValanceStyle
        if (
          allBags["MetalValanceStyleId"] !== undefined &&
          allBags["MetalValanceStyleId"] !== null &&
          allBags["MetalValanceStyleId"] !== ""
        ) {
          tempPostObj["SewingOrderDetails"][0]["MetalValanceStyleId"] =
            allBags["MetalValanceStyleId"];
        } else if (
          allBags["MetalValanceStyle"] !== undefined &&
          allBags["MetalValanceStyle"] !== null &&
          allBags["MetalValanceStyle"] !== ""
        ) {
          tempPostObj["SewingOrderDetails"][0]["MetalValanceStyleId"] =
            allBags["MetalValanceStyle"] === "MetalValance" ? 12901 : 12902;
          tempPostObj["SewingOrderDetails"][0]["MetalValanceStyleId"] =
            allBags["MetalValanceStyleId"];
        }

        // MetalValanceColorId
        if (
          allBags["MetalValanceColorId"] !== undefined &&
          allBags["MetalValanceColorId"] !== null
        ) {
          tempPostObj["SewingOrderDetails"][0]["MetalValanceColorId"] =
            allBags["MetalValanceColorId"];
        }

        // BottomBarId
        if (
          allBags["BottomBarId"] !== undefined &&
          allBags["BottomBarId"] !== null &&
          allBags["BottomBarId"] !== ""
        ) {
          tempPostObj["SewingOrderDetails"][0]["BottomBarId"] = allBags["BottomBarId"];
        }

        // RollTypeId
        if (allBags["RollTypeId"] !== undefined && allBags["RollTypeId"] !== null) {
          tempPostObj["SewingOrderDetails"][0]["RollTypeId"] = allBags["RollTypeId"];
        }

        // BracketTypeId
        if (allBags["BracketTypeId"] !== undefined && allBags["BracketTypeId"] !== null) {
          tempPostObj["SewingOrderDetails"][0]["BracketTypeId"] = allBags["BracketTypeId"];
        }

        // BracketColorId
        if (allBags["BracketColorId"] !== undefined && allBags["BracketColorId"] !== null) {
          tempPostObj["SewingOrderDetails"][0]["BracketColorId"] = allBags["BracketColorId"];
        }

        // ChainId
        if (allBags["ChainId"] !== undefined && allBags["ChainId"] !== null) {
          tempPostObj["SewingOrderDetails"][0]["ChainId"] = allBags["ChainId"];
        }

        // MotorProductId
        if (
          allBags["MotorProductId"] !== undefined &&
          allBags["MotorProductId"] !== null &&
          allBags["MotorProductId"] !== ""
        ) {
          tempPostObj["SewingOrderDetails"][0]["MotorProductId"] = allBags["MotorProductId"];
        }
        console.log(` allBags["RemoteName"]`, allBags["RemoteName"]);
        // MotorName
        if (
          allBags["RemoteName"] !== undefined &&
          allBags["RemoteName"] !== null &&
          allBags["RemoteName"] !== ""
        ) {
          tempPostObj["SewingOrderDetails"][0]["RemoteName"] = allBags["RemoteName"];
        }

        // MotorChannel
        if (allBags["MotorChannel"] !== undefined && allBags["MotorChannel"] !== null) {
          tempPostObj["SewingOrderDetails"][0]["MotorChannel"] = allBags["MotorChannel"];
        }

        // BackCordSideId
        if (allBags["BackCordSideId"] !== undefined && allBags["BackCordSideId"] !== null) {
          tempPostObj["SewingOrderDetails"][0]["BackCordSideId"] = allBags["BackCordSideId"];
        }

        // cordSideId
        if (allBags["CordSideId"] !== undefined && allBags["CordSideId"] !== null) {
          tempPostObj["SewingOrderDetails"][0]["CordSideId"] = allBags["CordSideId"];
        }

        // ControlType
        if (
          allBags["ControlType"] !== undefined &&
          allBags["ControlType"] !== null &&
          allBags["ControlType"] !== ""
        ) {
          // شرط جدید برای تبدیل مقدار ControlType
          let controlValue;
          if (allBags["ControlType"] === "Continuous Loop") {
            controlValue = "true";
          } else if (allBags["ControlType"] === "Motorized") {
            controlValue = "false";
          } else {
            controlValue = allBags["ControlType"]; // در صورت مقادیر دیگر، مقدار اصلی حفظ شود
          }

          tempPostObj["SewingOrderDetails"][0]["ControlType"] = controlValue;
        }

        fieldsToCopy.forEach((field) => {
          if (allBags.hasOwnProperty(field) && allBags[field] !== undefined) {
            tempPostObj["SewingOrderDetails"][0][field] = allBags[field];
          }
        });
        if (
          temp["SewingModelId"] === "0097" ||
          temp["SewingModelId"] === "0327" ||
          temp["SewingModelId"] === "0328"
        ) {
          applyRomanFeaturesToOrderDetails(tempPostObj["SewingOrderDetails"], temp["Features"]);
        }

        // Zebra (0303): map ControlPosition to CordSideId in SewingOrderDetails
        if (
          String(SewingModelId) === "0303" &&
          tempPostObj["ControlPosition"] != null &&
          tempPostObj["ControlPosition"] !== "" &&
          tempPostObj["SewingOrderDetails"] &&
          tempPostObj["SewingOrderDetails"][0]
        ) {
          if (tempPostObj["ControlPosition"] === "Left") {
            tempPostObj["SewingOrderDetails"][0]["CordSideId"] = 4401;
          } else if (tempPostObj["ControlPosition"] === "Right") {
            tempPostObj["SewingOrderDetails"][0]["CordSideId"] = 4402;
          }
        }

        if (tempPostObj.MountPositionId && tempPostObj["MountPositionId"] === 4803) {
          tempPostObj.ArcWidth = tempPostObj.Depth;
          tempPostObj.ArcHeight = tempPostObj.MouldingHeight;
        }

        if (tempPostObj["hasLead"] === "Yes" && tempPostObj["PageType"] === "Drapery&Sheers") {
          tempPostObj["SewingOrderDetails"][1]["LeadRequired"] = true;
        }
        if (tempPostObj["hasLead"] === "Yes" && tempPostObj["PageType"] === "SheersOnly") {
          tempPostObj["SewingOrderDetails"][0]["LeadRequired"] = true;
        }
        if (allBags["GrommetFinish"] && allBags["SewingModelId"] === "0099") {
          tempPostObj["SewingOrderDetails"][0]["GrommetColorId"] = getGrommetFinish(
            allBags["GrommetFinish"]
          );
        }
        if (
          allBags["SheerHeaderStyle"] &&
          allBags["SheerHeaderStyle"] === "Grommet" &&
          allBags["SewingModelId"] === "0099"
        ) {
          tempPostObj["SewingOrderDetails"][1]["GrommetColorId"] = getGrommetFinish(
            allBags["GrommetFinish"]
          );
        }
        axios
          .post(editIndex ? baseURLEditProject : baseURLAddProjectToCart, tempPostObj, {
            headers: authHeader(),
          })
          .then(() => {
            axios
              .get(baseURLGetCart, {
                headers: authHeader(),
              })
              .then((response) => {
                resolve(response.data ? response.data : {});
              })
              .catch((err) => {
                console.log(err);
                if (err.response && err.response.status === 401) {
                  refreshToken().then((response2) => {
                    if (response2 !== false) {
                      resolve(401);
                    } else {
                      navigate("/en" + "/User");
                      reject();
                    }
                  });
                } else {
                  resolve(false);
                }
              });
          })
          .catch((err) => {
            console.log(err);
            if (err.response && err.response.status === 401) {
              refreshToken().then((response2) => {
                if (response2 !== false) {
                  resolve(401);
                } else {
                  reject();
                }
              });
            } else {
              console.log("project not added to cart");
              resolve(false);
            }
          });
      } else {
        if (allBags["Mount"] === "Moulding") {
          tempPostObj["ArcWidth"] = allBags["Depth"];
          tempPostObj["ArcHeight"] = allBags["MouldingHeight"];
        }

        if (allBags["GrommetFinish"] && allBags["SewingModelId"] === "0099") {
          tempPostObj["SewingOrderDetails"][0]["GrommetColorId"] = getGrommetFinish(
            allBags["GrommetFinish"]
          );
        }
        if (
          allBags["SheerHeaderStyle"] &&
          allBags["SheerHeaderStyle"] === "Grommet" &&
          allBags["SewingModelId"] === "0099"
        ) {
          tempPostObj["SewingOrderDetails"][1]["GrommetColorId"] = getGrommetFinish(
            allBags["GrommetFinish"]
          );
        }

        if (
          allBags["MotorProductId"] !== undefined &&
          allBags["MotorProductId"] !== null &&
          allBags["MotorProductId"] !== ""
        ) {
          tempPostObj["SewingOrderDetails"][0]["MotorProductId"] = allBags["MotorProductId"];
        }

        if (localStorage.getItem("cart") === null) {
          let newCartObj = {};
          let newCartArr = [];
          newCartArr[0] = tempPostObj;
          newCartObj["drapery"] = newCartArr;
          newCartObj["product"] = [];
          newCartObj["swatches"] = [];
          console.log(`newCartObj`, newCartObj);
          localStorage.setItem("cart", JSON.stringify(newCartObj));
          customPageCart = newCartObj;
        } else {
          let cartObj = JSON.parse(localStorage.getItem("cart"));
          if (cartObj["drapery"] === undefined || cartObj["drapery"].length === 0) {
            let newCartArr = [];
            newCartArr[0] = tempPostObj;
            cartObj["drapery"] = newCartArr;
            console.log(`cartObj`, cartObj);
            localStorage.setItem("cart", JSON.stringify(cartObj));
            customPageCart = cartObj;
          } else {
            if (cartProjectIndex !== -1) {
              if (cartObj["drapery"][cartProjectIndex]) {
                cartObj["drapery"][cartProjectIndex] = tempPostObj;
                console.log(`cartObj`, cartObj);
                localStorage.setItem("cart", JSON.stringify(cartObj));
                customPageCart = cartObj;
              } else {
                customPageCart = cartObj;
              }
            } else {
              cartObj["drapery"].push(tempPostObj);
              console.log(`cartObj`, cartObj);
              localStorage.setItem("cart", JSON.stringify(cartObj));
              customPageCart = cartObj;
            }
          }
        }
        resolve(customPageCart);
      }
    }
  });
}

export default AddProjectToCart;
